import { FilterIcon } from './FilterIcon'

interface FilterButtonProps {
  onClick: () => void
}

export const FilterButton = ({ onClick }: FilterButtonProps) => {
  return (
    <button
      className='gap-2 h-10 appearance-none bg-white hover:bg-[#EBFBFF] md:rounded-lg md:shadow-[0px_1px_12px_0px_#EBF3FF,0px_0.4px_12px_0px_rgba(0,0,0,0.12)] text-[#00323D] text-base font-medium md:p-[12px_16px] inline-flex items-center justify-between focus:outline-none'
      onClick={onClick}
    >
      <span className='hidden md:inline'>Filters</span>
      <div className='w-4 h-4 relative overflow-hidden'>
        <FilterIcon />
      </div>
    </button>
  )
}
